<template>
  <div class="wrapper wrapper-content animated fadeInRight">
    <div class="ibox-content m-b-sm border-bottom">
      <div class="row form-horizontal">
        <div class="form-group  margin-0">
          <label class="col-sm-2 control-label">
            Title
          </label>
          <div class="col-sm-4">
            <div>
              <el-input v-model="searchName" name="search"></el-input>
            </div>
          </div>
        </div>
        <div class="form-group">
          <div class="col-sm-12 textRight">
            <div class>
              <el-button type="primary" @click="search">{{
                $t("message.Search")
              }}</el-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="row">
      <div class="col-sm-12">
        <div class="ibox float-e-margins">
          <div class="ibox-content">
            <div class="row table-responsive" style="padding-bottom:60px;">
              <div class="col-sm-12">
                <div class="pull-right">
                  <el-button @click="gotoDetail" v-if="checkPermission('publicity_LIST_ADD')">{{ $t("message.Add")
                  }}</el-button>
                  <el-button @click="showWarning" v-if="checkPermission('publicity_LIST_DEL')">{{ $t("message.Delete")
                  }}</el-button>
                </div>
              </div>
              <div class="col-xs-12">
                {{ total }}{{ $t("message.datagridresult") }}
              </div>
              <el-table :data="rows" border style="width: 100%" ref="multipleTable"
                @selection-change="handleSelectionChange" row-key="id" :cell-class-name="cell"
                :row-class-name='sortableFilter'>
                <el-table-column :selectable="handleSelectable" type="selection" width="55"></el-table-column>
                <el-table-column sortable prop="title" :show-overflow-tooltip="true" label="Title"
                  min-width="100"></el-table-column>
                <el-table-column sortable prop="createdAt" label="Created At" width="180">
                </el-table-column>
                <el-table-column sortable prop="subCount" label="Sub Count" width="120">
                </el-table-column>
                <el-table-column prop="statusName" label="Status" width="170">
                  <template slot-scope="scope">
                    {{ scope.row.isWebsiteGroup != 1 ? statusMap[scope.row.status] : '' }}
                  </template>
                </el-table-column>
                <el-table-column width="250">
                  <template slot-scope="scope">
                    <StatusBtn v-if="scope.row.isWebsiteGroup != 1" :id="scope.row.id" :status="scope.row.status"
                      :init="init" :type="'PUBLICITY'" :approval="'publicity_LIST_APPROVAL'"></StatusBtn>

                  </template>
                </el-table-column>
                <el-table-column label="Action" width="180" fixed="right">
                  <template slot-scope="scope">
                    <el-row>
                      <el-col :span="6" style="float:right" v-if="canDrag">
                        <div class="text-center dragTip">=</div>
                      </el-col>
                      <el-col :span="9" style="float: right">
                        <el-button :disabled="![5, 6].includes(scope.row.status)" size="mini"
                          @click="handlePreposition(scope.row)" icon="el-icon-caret-top"></el-button>
                      </el-col>
                      <el-col :span="9" style="float:right">
                        <el-button size="mini" @click="handleDbClick(scope.row)" icon="el-icon-edit"></el-button>
                      </el-col>
                    </el-row>

                  </template>
                </el-table-column>
              </el-table>
              <el-col :span="24" class="el-table_footertoolbar">
                <el-pagination layout="total, sizes, prev, pager, next, jumper" @size-change="handleSizeChange"
                  @current-change="handleCurrentChange" :page-sizes="[10, 20, 50, 100]" :page-size="pagesize"
                  :total="total" style="float:right;">
                </el-pagination>
              </el-col>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
  
<script>
import config from "../config";
import Sortable from "sortablejs";
import StatusBtn from "../components/common/statusBtn.vue";

export default {
  mixins: [config.globalMixin],
  components: { StatusBtn },
  data() {
    return {
      page: 1, //当前页数
      pagesize: 10, //一页显示几条
      total: 0,
      rows: [],
      multipleSelection: [],
      status: "",
      canDrag: true,
      searchName: ""
    };
  },
  created: function () { },
  computed: {
    statusMap() {
      return {
        0: 'Draft',
        1: 'Pending approval',
        2: 'Pending Publish',
        3: 'Rejected',
        4: 'Suspended',
        5: 'Pending Suspend',
        6: 'Published'
      }
    }
  },
  methods: {
    async init() {
      this.canDrag = true;
      var objdata = this.getAuthObj();

      objdata.pageIndex = this.page;
      objdata.pageSize = this.pagesize;
      objdata.title = this.searchName;
      objdata.parentId = 0

      objdata.apiUrl = this.apiConfig.publicityList;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.rows = data.data.result.publicityList;
      this.total = data.data.result.total;
    },
    async search() {
      this.page = 1;
      this.init();
    },
    cancel: function () {
      this.$store.commit("setwarning", { string: "", boolean: false });
    },
    cell: function ({ row }) {
      // if (!this.canDrag) {
      //   return "disabled pointer";
      // }
      // if (row.status == 1) {
      //   return "cursor-move";
      // } else {
      //   return "disabled pointer";
      // }
    },
    handleDbClick: function (row) {
      this.$router.push({
        path: "/main/publicityDetail",
        query: {
          id: row.id
        }
      });
    },
    async handlePreposition(item) {
      var objdata = this.getAuthObj();
      objdata.title = this.searchName;
      objdata.id = item.id;
      objdata.parentId = ''

      objdata.apiUrl = this.apiConfig.publicityPreposition;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      await this.init();
    },
    handleSelectable(row, index) {
      return row.isWebsiteGroup != 1
    },
    sortableFilter(item) {
      return [2, 5, 6].includes(item.row.status) ? '' : 'disabled'
    },
    gotoDetail() {
      this.$router.push({ path: "/main/publicityDetail" });
    },
    async deleteList() {
      let ids = [];
      let objdata = this.getAuthObj();
      if (this.multipleSelection.length != 0) {
        for (let i = 0; i < this.multipleSelection.length; i++) {
          ids.push(this.multipleSelection[i].id);
        }
      }
      objdata.ids = ids.join(',');

      objdata.apiUrl = this.apiConfig.publicityDelete;
      let data = await this.$store.dispatch("apiEventFromData", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      if (data.data.status_code === "0") {
        this.$store.commit("setwarning", {
          string: "",
          boolean: false,
          button: []
        });
        this.init();
      }
    },
    async updateNewsOrder(newIndex, oldIndex) {
      var item = this.rows[oldIndex];
      this.rows.splice(oldIndex, 1);
      this.rows.splice(newIndex, 0, item);
      let sortOrder = [];
      let objdata = this.getAuthObj();
      for (let i = 0; i < this.rows.length; i++) {
        sortOrder.push({
          id: this.rows[i].id,
          displayOrder: this.rows[i].sortOrder
        });
      }
      objdata.lstOrderDTO = sortOrder;

      objdata.apiUrl = this.apiConfig.publicityOrder;
      let data = await this.$store.dispatch("apiEvent", objdata);
      if (data == "000104") {
        this.timeoutEvent();
        return;
      }
      if (!data) return;
      this.init();

    }
  },
  mounted() {
    this.init();
    const table = document.querySelector(".el-table__body-wrapper tbody");
    var self = this;
    Sortable.create(table, {
      onEnd({ newIndex, oldIndex }) {
        self.updateNewsOrder(newIndex, oldIndex);
      },
      filter: ".disabled",
      onMove: event => {
        return !event.related.classList.contains("disabled");
      }
    });
  }
};
</script>
  